module.exports = __webpack_public_path__ + "media/images/search-icon-65bf77977681151f3f45a8215700390f.png";